import { getQuarterLabel } from '@aims/shared/reports/quarters';
import { gql, useMutation } from '@apollo/client';
import { Checkbox, Form, Input, Modal, notification, Typography } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import TaskSomethingForm from '../../../../tasks/ViewTaskModal/TaskSomethingForm';

export const updateHpReportAuditMutation = gql`
  mutation UpdateHpReportAudit(
    $projectId: ID!
    $reportAudit: HPReportAuditUpdateInput!
  ) {
    updateHpReportAudit(projectId: $projectId, reportAudit: $reportAudit)
  }
`;

const { Paragraph } = Typography;

const CommentReportAuditModal = ({ project, visible, onCancel, onFinish }) => {
  const { reportAudit } = visible || {};
  const [saving, setSaving] = useState(false);
  const [updateHpReportAudit] = useMutation(updateHpReportAuditMutation);
  const [form] = Form.useForm();

  useEffect(() => {
    if (reportAudit) {
      form.setFieldsValue({
        isExcused: reportAudit.isExcused,
        notes: reportAudit.notes,
      });
    } else {
      form.resetFields();
    }
  }, [form, visible, reportAudit]);

  const handleFinish = useCallback(
    async (values) => {
      setSaving(true);
      try {
        await updateHpReportAudit({
          variables: {
            projectId: project._id,
            reportAudit: {
              quarter: reportAudit.quarter,
              ...values,
            },
          },
        });

        notification.success({
          message: 'Saved',
          description: 'Comment saved successfully',
        });
        onFinish();
      } catch (err) {
        console.log(err);
        notification.error({
          message: 'Error',
          description: 'We apologize.  An error occurred.',
        });
      }
      setSaving(false);
    },
    [updateHpReportAudit, reportAudit, project, onFinish],
  );

  return (
    <Modal
      header={null}
      footer={null}
      open={visible}
      closable={!saving}
      destroyOnClose={true}
      maskClosable={!saving}
      onCancel={onCancel}
      styles={{ body: { paddingTop: 16 } }}
    >
      <TaskSomethingForm
        title="Add Comment to Report Audit"
        form={form}
        onFinish={handleFinish}
        onCancel={onCancel}
        saving={saving}
        saveText="Yes"
      >
        {reportAudit && (
          <Paragraph
            style={{ fontWeight: 600, fontSize: 18 }}
          >{`${getQuarterLabel(reportAudit.quarter)}`}</Paragraph>
        )}
        <Form.Item
          name="isExcused"
          valuePropName="checked"
          initialValue={false}
        >
          <Checkbox>Excuse this quarter from reporting</Checkbox>
        </Form.Item>
        <Form.Item name="notes">
          <Input.TextArea />
        </Form.Item>
      </TaskSomethingForm>
    </Modal>
  );
};

export default CommentReportAuditModal;
